<template>
  <div>
    <v-toolbar color="transparent" dense flat>
      <v-toolbar-title>{{$t('settings_blacklist')}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu bottom offset-y left>
        <v-btn icon slot="activator" class="mv-menu">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="(item, index) in menu"
            :key="index"
            @click="menuItemClicked(item.key)"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-divider></v-divider>

    <v-list subheader class="pa-3">
      <template v-for="(item, index) in blockedContacts">
        <v-list-tile
          :key="item.name + index"
          avatar
          @click="clicked(item)"
          @mouseover="mouseOver(index)"
        >
          <v-list-tile-avatar>
            <user-avatar 
              :avatar="item.avatar"
              :username="item.name" 
              :size="40"
            />
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>{{item.name}}</v-list-tile-title>
          </v-list-tile-content>

          <v-btn small v-show="selected==index" @click="unblockContact(item.contactId)">{{$t('contacts_unblock')}}</v-btn>

        </v-list-tile>
      </template>
      <div v-if="!blockedContacts || blockedContacts.length==0">{{$t('blacklist_no_data')}}</div>
    </v-list>
    <div class="modal-wrap">
      <UserSelector 
        :visible.sync="showUserSelector" 
        :title="$t('contacts_block')" 
        :callback="blockContacts" 
        :exclude="blockedContacts"
      />
    </div>
  </div>
</template>

<style>
</style>

<script>
  import UserAvatar from '@common/UserAvatar.vue'
  import UserSelector from '@common/UserSelector.vue'

  const UNBLOCK = 0
  const BLOCK = 1

  export default {
    components: { 
      UserAvatar,
      UserSelector
    },
    data() {
      return {
        blockedContacts: [],
        selected: -1,
        menu: [
          { title: this.$t('contacts_block'), key: BLOCK },
          { title: this.$t('blacklist_clear'), key: UNBLOCK },
        ],
        showUserSelector: false,
      }
    },
    mounted() { 
      this.fetchBlockedContacts()
    },
    methods: {
      fetchBlockedContacts() {
        this.blockedContacts = []
        this.$store.dispatch('fetchBlockedContacts').then(items => {
          items.forEach(contactId => {
            const con = this.$store.state.contacts.find(c => c.contactId == contactId)
            if(con)
              this.blockedContacts.push({ name: con.name, avatar: con.avatar, contactId: contactId })
            else
              this.blockedContacts.push({ name: contactId, avatar: "", contactId: contactId })
          })
          console.log(this.blockedContacts)
        })
      },
      mouseOver(index) {
        this.selected = index
      },
      unblockContact(contactId) {
        this.$store.dispatch('unblockContact', contactId)
      },
      contactBlocked(contactId) {
        const con = this.$store.state.contacts.find(c => c.contactId == contactId)
        if(con)
          this.blockedContacts.push({ name: con.name, avatar: con.avatar, contactId: contactId })
        else
          this.blockedContacts.push({ name: contactId, avatar: "", contactId: contactId })
      },
      contactUnblocked(contactId) {
        this.blockedContacts = this.blockedContacts.filter(item => item.contactId !== contactId)
      },
      menuItemClicked(key) {
        switch (key) {
          case UNBLOCK:
            this.unblockAll()
            break 
          case BLOCK:
            this.showUserSelector = true
            break
          default:
            throw new Error('-- unknown key: ' + key)
        }
      },
      unblockAll() {
        this.$store.dispatch('unblockAllContacts').then(() => {
          this.blockedContacts = []
        })    
      },
      blockContacts(selectedContacts) {
        selectedContacts.forEach(contactId => {
          this.$store.dispatch('blockContact', contactId)
        });

      },
      clicked(item) {
        // just an empty method
      }
    }
  }
</script>

